import React from 'react'

export default (props) =>
    <svg {...props} width="18" height="18" viewBox="0 0 7 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M1.55082 15.9419V8.44189H0V5.8566H1.55082V4.30508C1.55082 2.19744 2.42688 0.941895 4.91348 0.941895H6.98465V3.52719H5.69059C4.7224 3.52719 4.65757 3.88884 4.65757 4.56267L4.65416 5.8566H7L6.72532 8.44189H4.65416V15.9419H1.55082Z" fill="#F2E6D0"/>
    </svg>
